import React, { useEffect, useContext, useState } from 'react';
import DesktopHeader from './desktopHeader';
import MobileHeader from './mobileHeader';
import PageContext from '../../contexts/pageContext';
export default function Header({ data, isLandingPage, extraProps }) {
  const { isMobile, isTutorWebsite } = useContext(PageContext);

  const filterHiddenNavs = () => {
    return data?.navs?.filter((dt) => !dt.isHiddenNav);
  };

  return isMobile ? (
    <MobileHeader
      navData={filterHiddenNavs()}
      header={data}
      isTutorWebsite={isTutorWebsite}
      isLandingPage={isLandingPage}
      onDownloadAppTriggered={extraProps?.DownloadAppButtonTriggered}
      extraProps={extraProps}
    />
  ) : (
    <DesktopHeader
      navData={filterHiddenNavs()}
      header={data}
      isTutorWebsite={isTutorWebsite}
      isLandingPage={isLandingPage}
      onDownloadAppTriggered={extraProps?.DownloadAppButtonTriggered}
      extraProps={extraProps}
    />
  );
}
